import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export type OrderTypeFilterValue = 'all' | 'delivery' | 'pickup';

interface OrderTypeFilterProps {
  value: OrderTypeFilterValue;
  onValueChange: (value: OrderTypeFilterValue) => void;
  className?: string;
}

const OrderTypeFilter: React.FC<OrderTypeFilterProps> = ({
  value,
  onValueChange,
  className,
}) => {
  return (
    <div className={`flex items-center gap-2 ${className || ''}`}>
      <span className="text-sm font-medium">Order type:</span>
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger className="w-[160px]">
          <SelectValue placeholder="Select order type" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Orders</SelectItem>
          <SelectItem value="delivery">Delivery Only</SelectItem>
          <SelectItem value="pickup">Pickup Only</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default OrderTypeFilter;